import React, { CSSProperties } from 'react';

interface FireplaceProps {
	detailListStyle: CSSProperties,
	fireplaceFeatures: Array<string> | undefined,
	fireplacesTotal: number | undefined,
}

const Fireplace = ({ detailListStyle, fireplaceFeatures, fireplacesTotal }: FireplaceProps) => {
	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-fireplace me-2" />
				Fireplace
			</p>
			<ul style={detailListStyle}>
				{fireplaceFeatures ? (
					fireplaceFeatures.map((f: string, i: number) => {
						return <li key={i}>{f}</li>;
					})
				) : (
					<></>
				)}
				<li><span className="cc-font-weight--normal">Total fireplaces:</span> {fireplacesTotal || 'None Listed'}</li>
			</ul>
		</React.Fragment>
	);
};

export default Fireplace;
